var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"div"},[_c('homeMenu',{attrs:{"chooseMenu":"个人中心"}}),_c('userInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }